(function ($, Drupal) {
    Drupal.behaviors.careers = {
        attach: function (context, settings) {
            window.page = null;

            $("#exampleModal .close").click(function () {
                $("body").removeClass("modal-open");
                $('.modal-backdrop').css('display', 'none');
                $("#exampleModal").fadeOut();
                $('#gevoices-form').css("display", 'block');
                $('#mailchimp_subscribe_two').css("visibility", 'inherit');
                $('#subscribed-success').css("display", 'none');
                $("#ge-mail-message-two").css("display", "none");
                $(".ge-sso-div").hide();
            });
            $('.ge-take-actions .ge-btn', context).click(function () {
                console.log('ge-take-actions');
                $("body").addClass("modal-open");
                $('.modal-backdrop').css('display', 'block');
                $('#exampleModal').fadeIn("slow");
            });

            $('.xa100form .ge-btn', context).click(function () {
                console.log('xa100form');
                window.page = "xa100";
                $("body").addClass("modal-open");
                $('.modal-backdrop').css('display', 'block');
                $('#exampleModal').fadeIn("slow");
            });

            $('.t901-subscribe', context).off('click').on('click', function () {
                console.log('t901form');
                window.page = "t901";
                $("body").addClass("modal-open");
                $('.modal-backdrop').css('display', 'block');
                $('#exampleModal').fadeIn("slow");
            });
        
            $("#ge-employees").click(function () {
                if ($(this).is(":checked")) {
                    $(".ge-sso-div").show();
                } else {
                    $(".ge-sso-div").hide();
                    $(".gesso:text").val("");
                }
            });
        }
    }
})(jQuery, Drupal);